const MuiFormLabel = {
  styleOverrides: {
    root: {
      opacity: 1,
    },
  },
};

export default MuiFormLabel;
